/**
 * @author evdokimov
 */
import {ReportConfigConstants} from 'constants'
import $ from 'jquery'
import _ from 'underscore'
import messageResource from '../messageResource'
import makeRpcCall from '../util/jquery_rpc'
import {downloadJsonAsCSV} from '../csv/utils'
import indicateExportingOnButton from './indicateExportingOnButton'

export default function BaseFormMediator(){}

BaseFormMediator.prototype.init = function ( config )
{
    const self = this;

    this.reportsPageLink = ReportConfigConstants.REPORTS_DASHBOARD_URL;

    this.container = $( "#mainContainer" );

    this.dateRangeSelector = this.createDateRangeSelector( config.reportParameters );
    this.dateRangeSelector.setOnChangeCallback( function () {self.changeParametersCallback()} );

    ATReportsStore.setManageableUserIds(config.manageableUserIds)
    ATReportsStore.setProjectsWithMaIds(config.projectsWithMaIds)
    ATReportsStore.setReportAuthorizationInfo(config.reportAuthorizationInfo)

    this.configController = this.initEditConfigController( config );

    this.reportParamsStringBuilder = this.initParamsStringBuilder( config );

    this.reportPreviewPlaceholder = $( "#reportPreviewPlaceholder" );

    this.initButtons();
    this.initPreview();
    
    // global variable defined in messages.jsp
    if ( window.hasServerSideErrors ) 
        this.validateAndUpdateUIIfInvalid();
    
    return this;
};

BaseFormMediator.prototype.initParamsStringBuilder = function ( config )
{
    //abstract
};

BaseFormMediator.prototype.initPreview = function ()
{
    this.lastSuccessfulPreviewParameters = this.collectReportParameters();
    this.initPreviewGeneratorsAndGeneratePreview();
};

BaseFormMediator.prototype.initPreviewGeneratorsAndGeneratePreview = function ()
{
    this.htmlPeviewGenerator = this.initHtmlGenerator();
    this.csvPeviewGenerator = this.initCsvGenerator();
    this.switchOnHTMLPreview();
};

BaseFormMediator.prototype.initCsvGenerator = function ()
{
    // abstract
};

BaseFormMediator.prototype.initHtmlGenerator = function ()
{
    // abstract
};

BaseFormMediator.prototype.initEditConfigController = function ( config )
{
    // abstract
};

BaseFormMediator.prototype.changeParametersCallback = function ()
{
    if( !this.configController || !this.validateAndUpdateUIIfInvalid() )
        return;

    const oldLastSuccessfulPreviewParameters = this.lastSuccessfulPreviewParameters;
    this.lastSuccessfulPreviewParameters = this.collectReportParameters();
    if (this.htmlPreviewChosen === false)
        this.lastSuccessfulPreviewParameters.timeFormat = oldLastSuccessfulPreviewParameters.timeFormat;

    this.updatePreview();
};

BaseFormMediator.prototype.validateAndUpdateUIIfInvalid = function ()
{
    const controllsValidateResult = this.configController.validate();
    const dateRangeValidateResult = !this.dateRangeSelector.hasErrors();
    if(!dateRangeValidateResult){
        this.configController.setAdditionalError(this.dateRangeSelector.getErrorMessageKey());
    } else {
        this.configController.removeAdditionalError();
    }
    if( !controllsValidateResult || !dateRangeValidateResult){
        this.configController.updateUI( true );
    }


    return dateRangeValidateResult && controllsValidateResult;
};

BaseFormMediator.prototype.validate = function ()
{
    const dateRangeValidateResult = !this.dateRangeSelector.hasErrors();
    const controllsValidateResult = this.configController.validate();

    return dateRangeValidateResult && controllsValidateResult;
};

// default date range selector. must be override in concrete child if necessary
BaseFormMediator.prototype.createDateRangeSelector = function ( reportParameters )
{
    const dateRangeSelectorConfig = {
        dateRangeSelection: reportParameters.dateRangeSelection,
        menuStates: new DateRangeMenuItemsUtil().createDefaultDateRangeMenuItems( reportParameters.dateRangeSelection.qualifier ),
        shortDateFormat: true,
        callOnChangeCallbackIfInvalid: true
    };

    return new DateRangeSelectorController().init( dateRangeSelectorConfig );
};

BaseFormMediator.prototype.initButtons = function ()
{
    const self = this;
    
    const hoveredHtml = function () { self.container.addClass( "htmlHovered" ); };
    const unHoveredHtml = function () { self.container.removeClass( "htmlHovered" ); };
    
    const hoveredCsv = function () { self.container.addClass( "csvHovered" ); };
    const unHoveredCsv = function () { self.container.removeClass( "csvHovered" ); };

    $("#htmlPreviewTab").click( function () { self.switchOnHTMLPreview();} ).hover(hoveredHtml, unHoveredHtml);
    $("#csvPreviewTab").click( function () { self.switchOnCSVPreview();} ).hover(hoveredCsv, unHoveredCsv);

    this.applyHtmlButton = $( "#applyReportConfiguration" ).click( function () { self.onApply();} );
    this.applyCsvButton = $( "#genCSVReportConfiguration" ).click( function () { self.onApplyCSV();} );

    $( "#cancelReportConfiguration" ).click( function () { self.onCancel();} );
};

BaseFormMediator.prototype.collectReportParameters = function() {
    const reportParameters = {}
    this.fillDateSelection(reportParameters)
    return $.extend(reportParameters, this.configController.getConfig())
}

BaseFormMediator.prototype.onApply = function ()
{
    if( !this.validateAndUpdateUIIfInvalid() )
        return;

    this.submitForm();
};

BaseFormMediator.prototype.onApplyCSV = function ()
{
    if( !this.validateAndUpdateUIIfInvalid() )
        return;

    indicateExportingOnButton(this.applyCsvButton)
    this.exportToCSV();
};

BaseFormMediator.prototype.onCancel = function ()
{
    window.location.href = this.reportsPageLink;
};

BaseFormMediator.prototype.makeServiceParams = function (reportParams) {
    const serviceParams = _.clone(reportParams);
    serviceParams.dateRangeSelection = {
        qualifier: reportParams.dateRangeSelection.qualifier,
        fromDate: reportParams.dateRangeSelection.fromDate.toJSON(),
        toDate: reportParams.dateRangeSelection.toDate.toJSON()
    };

    return serviceParams;
};

BaseFormMediator.prototype.fillDateSelection = function ( reportParametersObject )
{
    reportParametersObject.dateRangeSelection = this.dateRangeSelector.getSelectedRange();
};

BaseFormMediator.prototype.switchOnCSVPreview = function ()
{
    if (this.htmlPreviewChosen === false)
        return;

    this.configController.switchTimeFormatBetweenCSVAndHTML(true);
    this.generatePreviewFnc = this.generateCSVPreview;
    this.container.removeClass( "html" );
    this.container.addClass( "csv" );
    this.applyHtmlButton.addClass( "hidden" );
    this.applyCsvButton.removeClass( "hidden" );
    this.updatePreview();
    this.htmlPreviewChosen = false;
};

BaseFormMediator.prototype.switchOnHTMLPreview = function ()
{
    if (this.htmlPreviewChosen === true)
        return;

    this.configController.switchTimeFormatBetweenCSVAndHTML(false);
    this.updateTimeFormatInLastSuccessfulPreviewParametersIfConfigurationValid();
    this.generatePreviewFnc = this.generateHtmlPreview;
    this.container.removeClass( "csv" );
    this.container.addClass( "html" );
    this.applyHtmlButton.removeClass( "hidden" );
    this.applyCsvButton.addClass( "hidden" );
    this.updatePreview();
    this.htmlPreviewChosen = true;
};

BaseFormMediator.prototype.updateTimeFormatInLastSuccessfulPreviewParametersIfConfigurationValid = function ()
{
    if (this.validate())
        this.lastSuccessfulPreviewParameters.timeFormat = this.configController.getConfig().timeFormat;
};

BaseFormMediator.prototype.submitForm = function ()
{
    const form = document.getElementById( "actionForm" );
    form["reportParameters"].value = JSON.stringify( this.collectReportParameters() );
    form.submit();
};

BaseFormMediator.prototype.exportToCSV = function ()
{
    const form = document.getElementById( "reportExportToCSVForm" );
    form["reportParameters"].value = JSON.stringify( this.collectReportParameters() );
    form.submit();
};

BaseFormMediator.prototype.updatePreview = function ()
{
    this.generatePreviewFnc( this.lastSuccessfulPreviewParameters );
};

BaseFormMediator.prototype.generateCSVPreview = function ( reportParameters )
{
    this.reportPreviewPlaceholder.empty()[0].appendChild( this.csvPeviewGenerator.generatePreviewTable( reportParameters, this.reportParamsStringBuilder ) );
};

BaseFormMediator.prototype.generateHtmlPreview = function ( reportParameters )
{
    this.reportPreviewPlaceholder.empty()[0].appendChild( this.htmlPeviewGenerator.generatePreviewTable( reportParameters ) );
};

BaseFormMediator.prototype.generateCSVName = function(generator, reportParams) {
    return generator.generateCSVName(reportParams);
};

BaseFormMediator.prototype._exportToCSV = function(reportParams, successFn, serviceName, serviceParams)
{
    const self = this;
    function successMethod(result)
    {
        const generator = successFn(result);
        
        const data = result.rootItem;
        downloadJsonAsCSV(generator.getJsons(reportParams, data), self.generateCSVName(generator, reportParams));
    }

    function errorMethod(jqXHR, textStatus, errorThrown)
    {
        if (textStatus === "rpc_customException")
        {
            let messageKey = null;

            switch (errorThrown.exception)
            {
                case "com.actimind.actitime.reports.AllSelectedUsersWereDeletedException":
                    messageKey = "userlist.js.error_all_selected_useds_deleted";
                    break;
                case "com.actimind.actitime.reports.AllSelectedLeaveTypesWereDeletedException":
                    messageKey = "report.common.all_selected_leave_types_deleted";
                    break;
            }

            if (messageKey)
            {
                alert(messageResource.getMessage(messageKey));
                window.location.reload();
                return true;
            }
        }

        return false;
    }
    
    return makeRpcCall(serviceName,
                       serviceParams,
                       successMethod,
                       errorMethod);
};


// WEBPACK FOOTER //
// ./web/js/reports/BaseFormMediator.js